import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { UserService } from './user.service';

export interface IItemLink {
	id: string;
	alias: string;
}

@Injectable({
	providedIn: 'root',
})
export class ItemLinkService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	get(rfid: string): Observable<IItemLink> {
		return this.http
			.get<{ statusCode: number; result: IItemLink }>(this.getUrl(rfid), {
				headers: this.userService.getHeaders(),
			})
			.pipe(map((response) => response.result));
	}

	pair(rfid: string, alias: string): Observable<IItemLink> {
		return this.http.post<{ statusCode: number; result: IItemLink }>(this.postUrl(), { id: rfid, alias }, { headers: this.userService.getHeaders() }).pipe(map((response) => response.result));
	}

	getUrl(rfid?: string) {
		return `${environment.awsEnvUri}/mes/itemlinks/${rfid}`;
	}

	postUrl() {
		return `${environment.awsEnvUri}/mes/itemlinks`;
	}
}
